export default __webpack_public_path__ + "static/media/rightsidegirl.0577bd1f08c350be40876501f003225f.svg";